import React from 'react';
const UpdateProducts = () => {
  return <div>UpdateProducts</div>;
};
export default UpdateProducts;
